export const GlobalConfig = {
    config: {
        apiUrl: "",
        siteID: 0,
        apiVersion: "v2",
        operatorAuthTokenId: "",
        applicationType: 0,
        domainID: "0",
        timeControl: undefined,
        initialTime: undefined,
        pageMethods: {
            SeamlessTokenLogin: () => { },
            JwtTokenLogin: () => { },
            LoginTwoStep: () => { }
        },
        player: {
            onLogout: {},
            onSecondStepLoginFailed: {},
            onNotLoggedIn: {},
            onTokenLoginReceived: {},
            onOneTimeTokenReceived: {},
            onSessionKeepAlive: {},
            onJwtLoginReceived: {},
            onTwoStepLoginContinue: {},
            loadUser: () => { },
            processLoginError: () => { },
            legacyWalletTokenLogin: () => { },
            logout: () => { },
            oneTimeTokenLoginFailed: () => { },
            showSessionExpired: () => { },
            continueLogin: () => { },
            proceedToSecondStep: () => { },
        },
        getIovationKey: () => ""
    }
};
//# sourceMappingURL=config.js.map